<template>
    <div class="flex flex-wrap gap-3 mb-6 justify-end items-center">
        <button @click="createModal"
            class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded transition-all duration-200 text-sm">
            + Yeni Sipariş Ekle
        </button>

        <input type="text" placeholder="Ara..." v-model="searchQuery"
        class="h-10 w-[300px] rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 px-4 text-sm text-primary-text dark:text-gray-100  focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
    </div>

    <div class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg dark:bg-primary-dark-bg  pb-3 shadow-md">
        <div class="w-full overflow-x-auto">
            <table class="min-w-full text-left text-sm text-secondary-text dark:text-gray-300">
                <thead class=" bg-gray-100 dark:bg-gray-800 font-medium">
                    <tr>
                        <th class="px-3 md:px-6 py-2 md:py-4">Sipariş No</th>
                        <th class="px-3 md:px-6 py-2 md:py-4">Sipariş Zamanı</th>
                        <th class="px-3 md:px-6 py-2 md:py-4">Ürün ID</th>
                        <th class="px-3 md:px-6 py-2 md:py-4">Sipariş Tonajı</th>
                        <th class="px-3 md:px-6 py-2 md:py-4">Bayi ID</th>
                        <th class="px-3 md:px-6 py-2 md:py-4">İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="order in paginatedOrders" :key="order.order_id"
                        class="border-b transition hover:light-hover dark:hover:dark-hover">
                        <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-primary-text dark:text-gray-100 ">{{
                            order.order_number }}</td>
                        <td class="px-3 md:px-6 py-2 md:py-4">{{ formatDate(order.order_time) }}</td>
                        <td class="px-3 md:px-6 py-2 md:py-4">
                            {{ order.ordered_products && order.ordered_products.length > 0 ? order.ordered_products.map(p => p.product.name).join(', ') : 'Ürün yok' }}
                        </td>
                        <td class="px-3 md:px-6 py-2 md:py-4">{{ }}</td>
                        <td class="px-3 md:px-6 py-2 md:py-4">{{ order.dealer_id }}</td>
                        <td class="px-3 md:px-6 py-2 md:py-4 flex gap-2">
                            <button @click="editModal(order)" class="relative group">
                                <PencilSquareIcon class="w-5 h-5 text-gray-500 hover:text-secondary-text" />
                                <span
                                    class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">Düzenle</span>
                            </button>
                            <button @click="deleteModal(order)" class="relative group">
                                <TrashIcon class="w-5 h-5 text-red-500 hover:text-red-600" />
                                <span
                                    class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">Sil</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <AppPagination :currentPage="currentPage" :totalPages="totalPages" @prev-page="currentPage--"
            @next-page="currentPage++" @go-to-page="page => currentPage = page" />

        <DeleteModal v-if="isDeleteModal" :item="selectedOrder"
            message="Bu siparişi silmek istediğinizden emin misiniz?" @close="isDeleteModal = false"
            @confirm-delete="handleDelete" @click.self="isDeleteModal = false" />

        <OrderModal v-if="isModal" :mode="modalMode" :order="selectedOrder" @submit="fetchOrders"
            @close="closeModal" />

    </div>
</template>

<script>
import { getApi, deleteApi } from "@/services/api";
import DeleteModal from '@/components/Modals/DeleteModal.vue';
import OrderModal from '@/components/Modals/OrderModal.vue';
import { PencilSquareIcon, TrashIcon } from '@heroicons/vue/24/outline';

export default {
    name: "OrderList",
    components: {
        PencilSquareIcon,
        TrashIcon,
        OrderModal,
        DeleteModal
    },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            searchQuery: "",
            modalMode: 'create',
            selectedOrder: null,
            isDeleteModal: false,
            isModal: false,
            orders: [],
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.filteredOrders.length / this.pageSize);
        },
        filteredOrders() {
            const query = this.searchQuery.toLowerCase();
            return this.orders.filter(order =>
                order.order_number.toLowerCase().includes(query)
            );
        },
        paginatedOrders() {
            const start = (this.currentPage - 1) * this.pageSize;
            return this.filteredOrders.slice(start, start + this.pageSize);
        },
    },
    mounted() {
        this.fetchOrders();
        this.fetchOrders();
    },
    methods: {
        formatDate(dateString) {
            const options = { year: 'numeric', month: 'short', day: 'numeric' };
            return new Date(dateString).toLocaleDateString(undefined, options);
        },
        createModal() {
            this.modalMode = 'create';
            this.selectedOrder = {};
            this.isModal = true;
        },
        editModal(order) {
            this.modalMode = 'edit';
            this.selectedOrder = order;
            this.isModal = true;
        },
        deleteModal(order) {
            this.selectedOrder = order;
            this.isDeleteModal = true;
        },
        closeModal() {
            this.isModal = false;
            this.selectedOrder = null;
            this.modalMode = 'create';
        },
        createOrder(newOrder) {
            this.orders.push(newOrder);
            this.closeModal();
        },
        updateOrder(updatedOrder) {
            const index = this.orders.findIndex(order => order.order_id === updatedOrder.order_id);
            if (index !== -1) {
                this.orders.splice(index, 1, updatedOrder);
            }
            this.closeModal();
        },
        async fetchOrders() {
            try {
                const response = await getApi('/orders');
                this.orders = response;
                
            } catch (error) {
                console.error("Siparişler alınırken hata oluştu:", error);
            }
        },
        async handleDelete(order_id) {
            try {
                await deleteApi(`/orders/id/${order_id}`);
                this.$toast.success("Sipariş başarıyla silindi!");
                this.fetchOrders();
            } catch (error) {
                this.$toast.error("Silme işlemi sırasında hata oluştu!");
            } finally {
                this.isDeleteModal = false;
            }
        },
    },
    watch: {
        searchQuery() {
            this.currentPage = 1;
        }
    }
};
</script>